<template>
<div class="flex">
  <div class="row no-gutters row-bordered row-border-light">
    <div :style="{ display }" class="col-md-5 pt-0 px-2 py-3" >
      <button @click="close()" type="button" class=" btn btn-dark btn-sm " style="font-size: 10px; float: right; padding: 0px 6px;">
            &times;
      </button>
       
      <div  class="py-4" style="padding-bottom: 0rem!important;">
        <div class="border border-dark">
          <vue-highcharts  :options="optionsChartBar " ref="lineChartsBar" style="height: 67vh;" :redraw="true"> </vue-highcharts>
        </div>
      </div>
    </div>
  <div class="py-3 px-2" :class="col" style="padding-bottom: 0.5rem!important;">
    <div class="border border-dark">
      <div class="p-1" style="height:70vh; background-color: white"  >

      <l-map  :zoom="zoom" :center="center" style="" ref="myMap" >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-control > 
              <div class="d-flex flex-column">
                  <b-form-select  v-model="selectedCountry" class="mb-3" @change="ChangeCountry" style="background-color:#00948a!important; color:#fff;">
                  <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option v-for="(countryName,index) in countryNameArray" :key="index"  :value="countryName" >{{countryName}}</b-form-select-option>
                  
                   
                  </b-form-select>
               
                 <!-- <b-form-select v-if="selectedCountry===4"  v-model="selected" class="mb-3" @change="ChangeDate" >-->
                  <!-- This slot appears above the options from 'options' prop -->
                 <!-- <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Date --</b-form-select-option>
                  </template>-->
                  <!-- These options will appear after the ones from 'options' prop -->
                 <!-- <b-form-select-option  v-for="i in dates" :key="i.extractWeek" :value="i.extractWeek" >{{i.extractWeek}}</b-form-select-option>
                  </b-form-select>-->
                  
              
          <div v-if="selectedCountry" class="rounded p-3" style="font: 14px/16px Arial, Helvetica, sans-serif; background: rgba(222, 222, 222, 0.9);">
            <div>
            <br>
            <div style="display:flex;align-items:center">
            <div style="background-color:#1C8BC2;border-radius:10px;height:10px;width:10px;margin-right:5px;">
            </div>
              <strong v-if="selectedCountry==='Italy'">0 - (1 - 24)</strong>
              <strong v-if="selectedCountry==='Ghana'">0 - (0 - 1)</strong>
              <strong v-if="selectedCountry==='France'">0</strong>
              <strong v-if="selectedCountry==='Germany'">0</strong>
              <strong v-if="selectedCountry==='Serbia'">0-18</strong>
              <strong v-if="selectedCountry==='Greece'">0-30</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#8EC4CD;border-radius:10px;height:10px;width:10px;margin-right:5px;"></div>
              <strong v-if="selectedCountry==='Italy'">1 - (25 - 57)</strong>
              <strong v-if="selectedCountry==='Ghana'">1 - (2 - 5)</strong>
              
              <strong v-if="selectedCountry==='France'">1-3</strong>
              <strong v-if="selectedCountry==='Germany'">1-4</strong>
              <strong v-if="selectedCountry==='Serbia'">19-55</strong>
              <strong v-if="selectedCountry==='Greece'">31-80</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
            <div style="background-color:#F7FFA7;border-radius:10px;height:10px;width:10px;margin-right:5px;">
            </div>
              <strong v-if="selectedCountry==='Italy'">2 - (58 - 103)</strong>
              <strong v-if="selectedCountry==='Ghana'">2 - (6 - 12)</strong>

              <strong v-if="selectedCountry==='France'">4-7</strong>
              <strong v-if="selectedCountry==='Germany'">5-7</strong>
              <strong v-if="selectedCountry==='Serbia'">56-115</strong>
              <strong v-if="selectedCountry==='Greece'">81-150</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#FDE97D;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">3 - (104 - 187)</strong>
              <strong v-if="selectedCountry==='Ghana'">3 - (13 - 20)</strong>
              <strong v-if="selectedCountry==='France'">8-10</strong>
              <strong v-if="selectedCountry==='Germany'">8-10</strong>
              <strong v-if="selectedCountry==='Serbia'">116-197</strong>
              <strong v-if="selectedCountry==='Greece'">151-250</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#FFD27D;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">4 - (188 - 282)</strong>
              <strong v-if="selectedCountry==='Ghana'">4 - (21 - 154)</strong>

              <strong v-if="selectedCountry==='France'">11-15</strong>
              <strong v-if="selectedCountry==='Germany'">11-15</strong>
              <strong v-if="selectedCountry==='Serbia'">198-202</strong>
              <strong v-if="selectedCountry==='Greece'">251-375</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#FFC262;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">5 - (283 - 412)</strong>
              <strong v-if="selectedCountry==='Ghana'">5 - (155 - 496)</strong>

              <strong v-if="selectedCountry==='France'">16-22</strong>
              <strong v-if="selectedCountry==='Germany'">16-22</strong>
              <strong v-if="selectedCountry==='Serbia'">203-313</strong>
              <strong v-if="selectedCountry==='Greece'">376-500</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#FBAE5F;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">6 - (413 - 618)</strong>
              <strong v-if="selectedCountry==='Ghana'">6 - (497 - 722)</strong>

              <strong v-if="selectedCountry==='France'">23-29</strong>
              <strong v-if="selectedCountry==='Germany'">23-36</strong>
              <strong v-if="selectedCountry==='Serbia'">314-482</strong>
              <strong v-if="selectedCountry==='Greece'">501-750</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#FB7C47;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">7 - (619 - 902)</strong>
              <strong v-if="selectedCountry==='Ghana'">7 - (723 - 996)</strong>

              <strong v-if="selectedCountry==='France'">30-59</strong>
              <strong v-if="selectedCountry==='Germany'">37-77</strong>
              <strong v-if="selectedCountry==='Serbia'">483-731</strong>
              <strong v-if="selectedCountry==='Greece'">751-1000</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#F94626;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">8 - (903 - 1418)</strong>
              <strong v-if="selectedCountry==='Ghana'">8 - (997 - 2323)</strong>

              <strong v-if="selectedCountry==='France'">60-205</strong>
              <strong v-if="selectedCountry==='Germany'">78-206</strong>
              <strong v-if="selectedCountry==='Serbia'">732-1225</strong>
              <strong v-if="selectedCountry==='Greece'">1001-1250</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center">
              <div style="background-color:#D40414; border-radius:10px;height:10px;width:10px;margin-right:5px;"></div>
              <strong v-if="selectedCountry==='Italy'">9 - (&gt; 1418)</strong>
              <strong v-if="selectedCountry==='Ghana'">9 - (&gt; 2323)</strong>

              <strong v-if="selectedCountry==='France'">&gt; 205</strong>
              <strong v-if="selectedCountry==='Germany'">&gt; 206</strong>
              <strong v-if="selectedCountry==='Serbia'">&gt; 1225</strong>
              <strong v-if="selectedCountry==='Greece'">&gt; 1250</strong>
              </div>
              
            <br>
          </div>
          </div>
          </div>
          
    </l-control>
    <l-control position="bottomright">          
               <div v-if="selectedCountry==='Italy' || selectedCountry==='France' || selectedCountry==='Germany' || selectedCountry==='Serbia'" class="p-2 ml-auto info-text" style="width:400px">
                <p  style= "text-align:justify;font-size:12px;"> Classes of mosquitoes’ abundance predictions at each trap, as produced by the MAMOTH generic data-driven model. The model uses satellite Earth Observation (environmental, meteorological, geomorphological), entomological and epidemiological data. </p>
               </div>           
    </l-control>
        <div v-if="tst" class="loader"></div>
        <div v-if="selectedCountry!=='Greece'">
          <div v-for="(i,index) in Mosquitoes_Abundance_Data" :key="index+'Mosquitoes_Abundance_Data'">
            <div v-if="selectedCountry==='Ghana'"> 
              <l-circle-marker
                              :lat-lng="[i.y, i.x]"
                              :fillColor="colors_Classification(i.class_prediction)"
                              :radius="8"
                              :stroke="false"
                              :fillOpacity="1"
                              v-on:mousemove="pointData=i.class_prediction"
                              >
                
                <l-tooltip>{{pointData}}</l-tooltip>
              </l-circle-marker>
            </div>
            <div v-else>
            <div v-if="selectedYear<2023" >
              <l-circle-marker
                              :lat-lng="[i.y, i.x]"
                              :fillColor="colors_Classification(i.class_prediction)"
                              :radius="8"
                              :stroke="false"
                              :fillOpacity="1"
                              v-on:mousemove="pointData=i.class_prediction"
                              >
                
                <l-tooltip>{{pointData}}</l-tooltip>
              </l-circle-marker>
            </div>
            <div v-if="selectedYear>2022" >
                <l-rectangle :bounds="i.bounds"
                :fillColor=colors_Classification(i.class_prediction)
                :color=colors_Classification(i.class_prediction)
                :weight=1 
                >
                  <l-tooltip class="text-center">{{i.class_prediction}} </l-tooltip>
                  <l-popup  style="font-size:11px; text-align: center;" >{{i.class_prediction}}</l-popup>
                </l-rectangle>
            </div>
          </div>
          </div>
        </div>
        <div v-if="selectedCountry==='Greece'">
        <l-circle-marker
                        v-for="i in badweek_data" :lat-lng="[i.y, i.x]"
                        :key="i.x"
                        :fillColor="colors_Classification(i['badweek'+value])"
                        :color="colors_Classification(i['badweek'+value])"
                        :fillOpacity="1"
                        :radius="5"
                        :weight="1"
                        @click="openChart(i)"
                        v-on:mousemove="settlementActive(i)"> 

          <l-popup  style="font-size:11px; text-align: center;" >{{nameOfSettlement}}</l-popup>
          <l-tooltip class="text-center">{{nameOfSettlementTooltip}}:<br/> {{i['badweek'+value]}} </l-tooltip>
        </l-circle-marker>
        </div>
        <l-polygon ref="polygon_country"
                v-for="(countryData,index) in polygon.latlngs" 
                :key="countryData.id" 
                :lat-lngs="countryData"
                :fillColor="countryColorArray[index]"
                :color="countryColorArray[index]"
                :fillOpacity="0.1"
                @click="focusOnCountry(index)"
              />
      </l-map>

      </div>
    </div>
  </div>
 
  </div>
  
  <div v-if="selectedCountry" class="px-2" >
  <div class="border border-dark ">
   <div  class="" style="width:100%; background-color:#FFFFFF; height: 130px;" >
    <div class="d-flex justify-content-between px-3">
      <div class="px-3 py-1">
      <p style="background-color:#d6d8db;" class="rounded p-2">Week:</p>
      </div>
      <b-form-select  v-model="selectedYear" class="mt-2" style="width:11%; background-color: #00948a; color:#fff" @change="ChangeYear">
                <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                  </template>

                  <!-- These options will appear after the ones from 'options' prop -->

                  <b-form-select-option v-for="year in years" :key="year.extractYear" :value="year.extractYear" >{{year.extractYear}}</b-form-select-option>
      </b-form-select>
    </div>
        <vue-slider class="px-4"  style="z-index:1005; " 
        ref="slider" 
        v-model="value"
        :marks="true"
        :data="data"
        @change="ChangeWeek">
        <template v-slot:step="{ active }">
        <div :class="['custom-step', { active }]"></div>
      </template>
        </vue-slider>
     
  </div>
  </div>
  </div>
  <b-modal id="modal-center" v-model="modalError" centered title="Error" hide-footer>
      <p class="my-4">No Data Available</p>
    </b-modal>
</div>
</template>

<script>
import {LMap, LTileLayer, LCircle,LCircleMarker, LPolygon,LControl, LMarker,LPopup,LTooltip,LRectangle} from 'vue2-leaflet';
import axios from '../axios-auth'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueHighcharts from 'vue2-highcharts'
import {MyFunctions} from "../components/colorClassificationsMAb";
import routes from '../routes/routes'
export default {
  components: {
    VueHighcharts,
    LPopup,
    VueSlider,
    LMap,
    LTileLayer,
    LCircle,
    LCircleMarker,
    LPolygon,
    LControl,
    LMarker,
    LTooltip,
    LRectangle
  },
  data(){
    return{
      modalError:false,
      selected_country_old:null,
      countryNameArray:[],
      countryColorArray:['#3388ff','#3388ff','#3388ff','#3388ff','#3388ff'],
      polygon: {
        latlngs: [],
      },
      pointData:null,
      display: 'none',
      nameOfSettlement:'',
      nameOfSettlementTooltip:'',
      charts:false,
      col: 'col-md-12',
      selectedYear:'2020',
      year:'',
      errorMsg:'',
      tst:true,
      Mosquitoes_Abundance_Data:'',
      dates:'',
      years:'',
      selected:null,
      selectedCountry:null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 3,
      center: [43.6659, 17.1937],
      colors:['#1C8BC2','#8EC4CD','#F7FFA7','#FDE97D','#FFD27D','#FFC262','#FBAE5F','#FB7C47','#F94626','#D40414'],

      value: 16,
      data:[16, 17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39],
        
        
      
      optionsChartBar:{
        chart: {
          type: 'column'

        },
        title: {
          text: ''
        },
        yAxis: {
          title: {text:'',},
          tickAmount: 10
        },
        credits: {
          enabled: false
        },
        series: [],
      },
      group:null,
      countryArray:['Italy','Ghana'],
    }

    
  },
  async created() {
    
    var country_geom=null
    var user =JSON.parse(localStorage.getItem('user'))
    
    this.group = user.groups
    var country_geom=null
    
    country_geom=await axios.get('entomologicalData/country/',{params:{group:JSON.stringify(this.group)}})////.catch(error=> routes.replace('/'))
    
    

    this.country=country_geom.data
    //console.log(this.country)
    var k=0;
    for(var i=0; i<country_geom.data.length; i++) {
      
      if(this.countryArray.includes(this.country[i].name)){
      this.countryNameArray.push(this.country[i].name)
      //console.log(this.countryNameArray)

      const latlgn = L.geoJSON(JSON.parse(this.country[i].json))
      const latlgn_id = latlgn._leaflet_id - 1
      // console.log(latlgn)
      const latlgn_data = latlgn._layers[latlgn_id]._latlngs

      this.polygon.latlngs[k] = latlgn_data
      k++
      }
    }
    console.log(this.polygon.latlngs.length)
    if(!this.polygon.latlngs.length){
      this.modalError=true
    }

    /*const years_all=await axios.get('mosquitoes-abundance/human-cases-years/',{headers: { Authorization: `Bearer ${token}` }})
    this.years=years_all.data
    this.selectedYear=this.years[0].extractYear
    await this.Weeks()
    //console.log(this.dates)
    this.value=this.dates[0].extractWeek
    
    this.MosquitoesAbundanceData()
    */
    /*const Mosquitoes_Abundance_all = await axios.get('mosquitoes-abundance/',{
      headers: { Authorization: `Bearer ${token}` },
      params: {week: this.dates[0].extractWeek, year: this.years[0].extractYear}
    })

    this.Mosquitoes_Abundance_Data = Mosquitoes_Abundance_all.data
    */
    
    //console.log(this.Mosquitoes_Abundance_Data)
    //this.selected=this.dates[0].extractWeek
    //const token = localStorage.getItem('token')
    //const badweek_all=await axios.get('mosquitoes-abundance/weekly_Gr/',{headers: { Authorization: `Bearer ${token}` }})
    //this.badweek_data=badweek_all.data
    //console.log('badWeek_data',this.badweek_data)

    this.tst=false

  },
  methods: {
    getBoundingBox(center) {
      const distance = 1; // distance in kilometers
      const R = 6371; // radius of the earth in kilometers
      const dLat = distance / R;
      const dLon = distance / (R * Math.cos(Math.PI / 180 * center[0]));
      const minLat = center[0] - dLat * 180 / Math.PI;
      const maxLat = center[0] + dLat * 180 / Math.PI;
      const minLon = center[1] - dLon * 180 / Math.PI;
      const maxLon = center[1] + dLon * 180 / Math.PI;
      return [[minLat, minLon],[maxLat, maxLon]];
    },
    async MosquitoesAbundanceData(){
      const token = localStorage.getItem('token')
      const Mosquitoes_Abundance_all = await axios.get('mosquitoes-abundance/',{
        headers: { Authorization: `Bearer ${token}` },
        params: {week: this.value, year: this.selectedYear, country: this.selectedCountry,type:'Anopheles'}
      })////.catch(error=> routes.replace('/'))
      this.Mosquitoes_Abundance_Data = Mosquitoes_Abundance_all.data
      if(this.selectedYear>2022){
        for(var yy=0; yy<this.Mosquitoes_Abundance_Data.length; yy++){
          this.Mosquitoes_Abundance_Data[yy].bounds= this.getBoundingBox([this.Mosquitoes_Abundance_Data[yy].y,this.Mosquitoes_Abundance_Data[yy].x]);
        }
      }
      //console.log(this.Mosquitoes_Abundance_Data )
    },
    async Weeks(){
      const token = localStorage.getItem('token')
      const dates_all=await axios.get('mosquitoes-abundance/human-cases-dates/',{
      headers: { Authorization: `Bearer ${token}` },
      params: {year: this.selectedYear, country: this.selectedCountry,type:'Anopheles'}
      })////.catch(error=> routes.replace('/'))
    this.dates=dates_all.data
    },
    
    async ChangeCountry(){
      this.close()
      var num=this.countryNameArray.indexOf(this.selectedCountry)
      this.countryColorArray[num]='#EC008C'
      
    if(this.selected_country_old!==null){
      
      this.countryColorArray[this.selected_country_old]='#3388ff'
    }
    
    this.selected_country_old=num

     // console.log(this.$refs.slider)
     if(this.selectedCountry === 'Greece'){
       this.$refs.myMap.mapObject.fitBounds([[40.7634502432201, 23.9569594997323], [35.8924119881264, 23.8465820717025]])
        this.value= 16
        this.data=[16, 17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39]


     }
     else{
        this.tst=true
        if(this.selectedCountry==='Italy'){
          this.$refs.myMap.mapObject.fitBounds([[46.2634502432201,13.0569594997323],[43.6924119881264,12.1465820717025]])
        }else if(this.selectedCountry==='France'){
          this.$refs.myMap.mapObject.fitBounds([[48.864716,2.349014],[40.864716,6.349014]])

        }else if(this.selectedCountry==='Germany'){
          this.$refs.myMap.mapObject.fitBounds([[52.520008,15.404954],[46.520008,8.404954]])

        }else if(this.selectedCountry==='Serbia'){
          this.$refs.myMap.mapObject.fitBounds([[47.787197,23.8569594997323],[41.087197,18.6465820717025]])

        }else if(this.selectedCountry==='Ghana'){
          this.$refs.myMap.mapObject.flyTo([5.614818, -0.205874],5)

        } 
        const token = localStorage.getItem('token')
        const years_all=await axios.get('mosquitoes-abundance/human-cases-years/',{
          headers: { Authorization: `Bearer ${token}` },
          params: { country: this.selectedCountry,type:'Anopheles'}
          })////.catch(error=> routes.replace('/'))
        this.years=years_all.data
        this.selectedYear=this.years[0].extractYear
        await this.Weeks()
        //console.log(this.dates)
        this.value=this.dates[0].extractWeek
        
        this.MosquitoesAbundanceData()
        this.selected=this.dates[0].extractWeek
        this.tst=false
        this.data=[]
        //this.data.push('0')
        //var res=''
        //console.log("res" , res)
        for(var i=0; i<this.dates.length; i++){  
          this.data.push(this.dates[i].extractWeek)
        }
         
        //this.year=res[0]
      
        this.value=this.data[0]
      //  console.log(this.data)
        
      }
     
    },

    colors_Classification(data){
      if(this.selectedCountry==='Greece'){
        return MyFunctions.colors_Gr(data)
      }
      else if(this.selectedCountry==='Italy' ||this.selectedCountry==='Ghana'){
        return MyFunctions.colors_It_anopheles(data)
      }
      else if(this.selectedCountry==='France'){
        return MyFunctions.colors_Fr(data)
      }
      else if(this.selectedCountry==='Germany'){
        return MyFunctions.colors_Ge(data)
      }
      else if(this.selectedCountry==='Serbia'){
        return MyFunctions.colors_Se(data)
      }
    },
    callbackRange (val) {
      this.rangeValue = val
    },
    ChangeWeek(){
     // console.log(this.value)
      if(this.selectedCountry!=='Greece' && this.value!=='0'){
        this.MosquitoesAbundanceData()
      }
      if(this.value==='0'){
        this.Mosquitoes_Abundance_Data=null
      }
    },

    openChart(i){

        this.nameOfSettlement=i.settlement
      
        this.display='block'
       // console.log(i)
        this.col='col-md-7'
        this.charts=true
        //this.$refs.myMap.mapObject.invalidateSize();
        var lineChartsBar = this.$refs.lineChartsBar
        
        if (lineChartsBar) {
        lineChartsBar.removeSeries()
        }
        var col=[]
        for(var j=16; j<40; j++){
          var colortest= this.colors_Classification(i['badweek'+j])
          col.push({y: i['badweek'+j], color:colortest})
           /*
           lineChartsBar.addSeries({
           name: "test"+j,
           data: [i['badweek'+j]],
          
          })
          */
        }
      //  console.log(col)
       lineChartsBar.getChart().xAxis[0].setCategories(this.data)
       lineChartsBar.addSeries({
           name: "Week",
           data: col,
          
          })
       
      lineChartsBar.getChart().setTitle({text:i.settlement})
      
    
    },
    settlementActive(i){
      this.nameOfSettlementTooltip=i.settlement
    },
    async ChangeYear(){
      await this.Weeks()
      this.data=[]
      //this.data.push('0')
        
        for(var i=0; i<this.dates.length; i++){  
          this.data.push(this.dates[i].extractWeek)
        }
        
        this.value=this.data[0]

        this.MosquitoesAbundanceData()
    },
    focusOnCountry(index){
      if(this.countryNameArray[index]!==this.selectedCountry){
      this.selectedCountry=this.countryNameArray[index]
      this.ChangeCountry()
      }
    },
    close(){
      this.display='none'
     
      this.col='col-md-12'
      
    },
  }
}
</script>

<style>
.custom-step {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: 0 0 0 3px #ccc;
    background-color: #fff;
  }
  .custom-step.active {
    box-shadow: 0 0 0 3px #3498db;
    background-color: #3498db;
  }
  .leaflet-popup-content {
    width: 80px;
    
  }
  .vue-slider-dot-handle {

    background-color: #00948a!important ;
    }
  .vue-slider-process {
    background-color: #00948a!important;
}
.custom-step.active {
    box-shadow: 0 0 0 3px #00948a!important;
    background-color: #00948a!important;
}
.vue-slider-dot-tooltip-inner {
    border-color: #00948a!important;
    background-color: #00948a!important;
}
</style>
